export enum DisplayBoardTypeId {
  Workflow = 1,
  Family = 2,
  Patient = 3,
  Asset_PAR_Level = 4,
}
